export const GET_MARKET_DATA = 'GET_MARKET_DATA';
export const GET_ALL_MARKET_DATA = 'GET_ALL_MARKET_DATA';
export const GET_SUPPLIED_MARKET_DATA = 'GET_SUPPLIED_MARKET_DATA';
export const GET_BORROWED_MARKET_DATA = 'GET_BORROWED_MARKET_DATA';
